const Button = (props) => {
  return <button type="button" {...props}></button>;
};

export default Button;
